<div class="button-single-line-arrow">
  <div class="bsla-icon-default" *ngIf="fixedColor && iconObject === null" [inlineSVG]="icon"></div>
  <div class="bsla-icon" *ngIf="!fixedColor && iconObject === null" [style.--icon]="iconCss"></div>
  <div class="bsla-icon" *ngIf="iconObject !== null"><img [src]="iconObject" /></div>
  <div [ngClass]="{ 'bsla-text': true, 'bsla-text-wi': showIcon(), 'bsla-text-wp': withPadding && !showIcon() }"><ng-content></ng-content></div>
  <div class="bsla-arrow" *ngIf="showArrow" [inlineSVG]="'assets/images/forward.svg'"></div>
</div>
